import { useMemo, useRef, useState } from "react";

import { useStateValue } from "../../stateProvider/stateProvider";
import Back from "../Back/Back";
import { AddEditSelect } from "../Filter/Filter";
import { ADD_INITIAL_FORM, createAddController } from "./addController";
import "./add.css";

const Add = ({
  getData,
  formaty,
  categories,
  setInfoType,
  setInfo,
}) => {
  const [reducer] = useStateValue();
  const [formData, setFormData] = useState(ADD_INITIAL_FORM);
  const addModalRef = useRef();

  const controller = useMemo(
    () =>
      createAddController({
        choosenTable: reducer.choosenTable,
        getData,
        setInfoType,
        setInfo,
        setFormData,
        modalRef: addModalRef,
      }),
    [reducer.choosenTable, getData, setInfoType, setInfo]
  );

  const setFieldValue = (field, value) => {
    setFormData((previous) => ({
      ...previous,
      [field]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await controller.submitForm(formData);
  };

  return (
    <div className="add" ref={addModalRef}>
      <span onClick={controller.clearForm}>
        <Back />
      </span>

      <form className="add-form">
        <div className="add-input-div  add-div-small">
          <label className="add-label" htmlFor="campaign">
            Kampania:
          </label>

          <input
            type="text"
            placeholder="Wpisz"
            name="campaign"
            value={formData.Kampania}
            onChange={(event) => setFieldValue("Kampania", event.target.value)}
          />
        </div>
        <div className="add-input-div  add-div-small">
          <label className="add-label" htmlFor="client">
            Klient:
          </label>

          <input
            type="text"
            placeholder="Wpisz"
            name="client"
            value={formData.Klient}
            onChange={(event) => setFieldValue("Klient", event.target.value)}
          />
        </div>
        <AddEditSelect
          val={formData.Format}
          title="Format"
          opts={formaty}
          set={(value) => setFieldValue("Format", value)}
        />
        <AddEditSelect
          val={formData.Kategoria}
          title="Kategoria"
          defaultt=""
          opts={categories}
          set={(value) => setFieldValue("Kategoria", value)}
        />
        <div className="add-input-div add-div-medium">
          <label className="add-label" htmlFor="link">
            Link:
          </label>

          <input
            placeholder="Wklej"
            type="text"
            name="link"
            value={formData.Link}
            onChange={(event) => setFieldValue("Link", event.target.value)}
          />
        </div>
        <div className="add-button-div">
          <button className="add-submit " type="submit" onClick={handleSubmit}>
            Dodaj
          </button>
        </div>
      </form>
    </div>
  );
};

export default Add;
